import type { MiddlewareHandler } from "hono";

function normalizeHost(value: string | null | undefined): string {
  const raw = (value || "").trim().toLowerCase().replace(/\.+$/, "");
  if (!raw) return "";
  if (raw.startsWith("[") && raw.includes("]")) return raw.slice(1, raw.indexOf("]"));
  return raw.split(":")[0] || "";
}

function normalizePlatformDomain(value: string): string {
  return normalizeHost(value) || "gencow.app";
}

export function buildOfficialDomainCanonicalURL(
  requestURL: string,
  hostHeader: string | null | undefined,
  platformDomain: string,
): string | null {
  const officialDomain = normalizePlatformDomain(platformDomain);
  const requestHost = normalizeHost(hostHeader || new URL(requestURL).host);
  if (requestHost !== `www.${officialDomain}`) return null;

  const target = new URL(requestURL);
  target.protocol = "https:";
  target.host = officialDomain;
  return target.toString();
}

export function createOfficialDomainCanonicalRedirectMiddleware(platformDomain: string): MiddlewareHandler {
  return async (c, next) => {
    const canonicalURL = buildOfficialDomainCanonicalURL(c.req.url, c.req.header("host"), platformDomain);
    if (!canonicalURL) {
      await next();
      return;
    }

    return new Response(null, {
      status: 308,
      headers: { Location: canonicalURL },
    });
  };
}
